import React from 'react'

import SignUpHeader from '@/legacy-src/components/SignUpHeader'

import { getTranslate } from '../utilities/i18n'

const ErrorComponentGeneral: React.FC = () => {
  const { t } = getTranslate()
  return (
    <div className="container flex h-screen flex-col">
      <SignUpHeader />
      <div className="flex flex-grow flex-col items-center justify-center pb-[25%]">
        <h2>{t('component.errorPage.heading')}</h2>
        <p className="mb-12">{t('component.errorPage.subheading')}</p>
      </div>
    </div>
  )
}

export default ErrorComponentGeneral
